import { Box, Icon, Typography } from "@drone-js/core";
import type { FunctionComponent } from "react";

interface Props {
    title: string;
    description: string;
}

export const BenefitItem: FunctionComponent<Props> = ({ title, description }) => (
    <Box gap="12" display="flex" flexDirection="row">
        <Icon id="fill.symbol.check" size="20" p="2" data-testid="icon" />
        <Box gap="4" display="flex" flexDirection="column">
            <Typography variant="body-default">{title}</Typography>
            <Typography variant="body-default" textColor="base.subtle">
                {description}
            </Typography>
        </Box>
    </Box>
);
